/**
 * フォーム関連の調整用
 */
const errMsg = () => {
    const fields = document.querySelectorAll('.c-field');
    if (fields.length <= 0) return;

    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        const err = field.getElementsByClassName('error')[0];
        if (!err) continue;

        const label = field.getElementsByClassName('c-field-label')[0];

        err.parentNode.classList.add('c-field-error');
        if (label.tagName === 'DIV' || !label) continue;

        label.appendChild(err);
    }
};

window.addEventListener('DOMContentLoaded', errMsg, false);


// WEBPACK FOOTER //
// ./js/modules/form.js